import Repository from './repository';

const resource = '/m2m';
export default {
	create(payload) {
		return Repository.postWithAuth(
			`${resource}/create`,
			payload,
			{},
			{ noCache: true }
		);
	},
	find(payload) {
		return Repository.postWithAuth(`${resource}/find`, payload);
	},
	revoke(id) {
		return Repository.getWithAuth(`${resource}/revoke/${id}`);
	},
	update(payload) {
		return Repository.postWithAuth(
			`${resource}/update/${payload.id}`,
			payload,
			{},
			{ noCache: true }
		);
	},
	delete(id) {
		return Repository.deleteWithAuth(`${resource}/delete/${id}`);
	},
};
